import React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './UI/templates/App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
reportWebVitals();


serviceWorker.register();
